@if (_active) {
  <kendo-window
    title="{{ _isNew ? 'Add new record' : 'Edit stock' }}"
    (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm">
    <form novalidate
      [formGroup]="_form"
      (keydown.enter)="$event.preventDefault()"
      class="form_style">
      <div class="row">
        <div class="col-12">
          <div class="Transfer-section-header">
            <div class="Transfer-section-header-title">Transfer Request</div>
            <div class="header-actions">
              @if (!_isProcessed) {
                <button class="asap-btn"
                  kendoButton
                  (click)="_onSave($event)"
                  >
                  <span>
                    <img [src]="'/assets/menu/'+ _theme +'/save-close-icon.svg'" />
                  </span>Save & Close
                </button>
              }
              <button class="asap-btn" kendoButton (click)="_onCancel()">
                <span>
                  <img [src]="'/assets/menu/'+ _theme +'/close-icon.svg'" />
                </span>Close
              </button>
              <!-- <button class="asap-btn" kendoButton>
              <span><img [src]="'/assets/menu/'+ _theme +'/save-add-icon.svg'" /></span>Save
              & New
            </button>
            <button class="asap-btn" kendoButton>
              <span><img [src]="'/assets/menu/'+ _theme +'/save-copy-icon.svg'" /></span>Save
              & Copy
            </button>
            <button class="asap-btn" kendoButton>
              <span><img [src]="'/assets/menu/'+ _theme +'/save-icon.svg'" /></span>Save
            </button> -->
          </div>
        </div>
      </div>
    </div>
    <div class="row no-row-margin">
      <div class="col-12 col-xl-7 small-pad-right">
        <div class="TransferWidget">
          <div class="row">
            <div class="col-12 col-xl-6">
              <div class="row">
                <div class="col-12">
                  <p class="titleStandardStyle">Transfer from</p>
                </div>
                <div class="col-12 margin-top-10">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-2">
                          <label class="control-label">From Account</label>
                        </div>
                        <div class="col-10 combobox_contaainer">
                          <accounts-dropdown #kendo_combo_fromaccounts
                            [disabled]="_model != null && _model.id != null"
                            class="bordered whiteselect"
                            placeholder="Select From Account"
                            (accountChanged)="_fromAccountsSelectionChanged($event)"
                            formControlName="accountfromid"
                            [(ngModel)]="_selectedFromAccounts"
                            [required]="true">
                          </accounts-dropdown>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-2">
                          <label class="control-label">From Site</label>
                        </div>
                        <div class="col-10 combobox_contaainer">
                          <kendo-combobox #kendo_combo_fromsites
                            [data]="_fromSites"
                            [disabled]="_form.get('accountfromid').value == null || (_model != null && _model.id != null)"
                            [suggest]="true"
                            class="bordered whiteselect"
                            [textField]="'name'"
                            [valueField]="'id'"
                            placeholder="Select From Site"
                            (selectionChange)="_fromSitesSelectionChanged($event)"
                            formControlName="sitefromid"
                            [(ngModel)]="_selectedFromSites"
                            required>
                          </kendo-combobox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-xl-6">
              <div class="row">
                <div class="col-12">
                  <p class="titleStandardStyle">Transfer to</p>
                </div>
                <div class="col-12 margin-top-10">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-2">
                          <label class="control-label">To Account</label>
                        </div>
                        <div class="col-10 combobox_contaainer">
                          <accounts-dropdown #kendo_combo_toaccounts
                            [disabled]="_form.get('accountfromid').value == null || _form.get('sitefromid').value == null || (_model != null && _model.id != null)"
                            class="bordered whiteselect"
                            placeholder="Select To Account"
                            (accountChanged)="_toAccountsSelectionChanged($event)"
                            formControlName="accounttoid"
                            [(ngModel)]="_selectedToAccounts"
                            [required]="true">
                          </accounts-dropdown>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-2">
                          <label class="control-label">To Site</label>
                        </div>
                        <div class="col-10 combobox_contaainer">
                          <kendo-combobox #kendo_combo_tosites
                            [data]="_toSites"
                            [disabled]="_form.get('accountfromid').value == null || _form.get('sitefromid').value == null || _form.get('accounttoid').value == null || (_model != null && _model.id != null)"
                            [suggest]="true"
                            class="bordered whiteselect"
                            [textField]="'name'"
                            [valueField]="'id'"
                            placeholder="Select To Site"
                            (selectionChange)="_toSitesSelectionChanged($event)"
                            formControlName="sitetoid"
                            [(ngModel)]="_selectedToSites"
                            required>
                          </kendo-combobox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="section-separator"></div>
            </div>
            <div class="col-12 col-xl-6">
              <div class="row">
                <div class="col-2">
                  <label class="control-label">Notes</label>
                </div>
                <div class="col-10 combobox_contaainer">
                  <textarea id=""
                    name=""
                    class="Transfer_notes_textarea"
                  formControlName="notes"></textarea>
                </div>
              </div>
            </div>
            <div class="col-12 col-xl-6">
              <div class="row">
                <div class="col-2">
                  <label class="control-label">Schedule Date</label>
                </div>
                <div class="col-10 combobox_contaainer">
                  <kendo-datepicker [format]="'yyyy/MM/dd'"
                    (valueChange)="_onScheduleDateChange($event)"
                    formControlName="scheduledate"
                    class="smalldatePicker">
                  </kendo-datepicker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-xl-5 small-pad-left">
        <div class="TransferWidget">
          <div class="row">
            <div class="col-12">
              <p class="titleStandardStyle">Select or Scan Stock Item #</p>
            </div>
            <div class="col-12 display-flex margin-top-10">
              <div class="row flex-1">
                <div class="col-4">
                  <label class="control-label">Stock Item #</label>
                </div>
                <div class="col-8 combobox_contaainer">
                  <kendo-combobox #kendo_combo_items
                    [data]="_itemsFiltered"
                    [filterable]="true"
                    (opened)="scrollCombobox($event)"
                    (valueChange)="_handleItemsChange($event)"
                    (filterChange)="_handleItemsFilter($event)"
                    [formControl]="_selectedStockItem"
                    (blur)="onBlur()"
                    [suggest]="true"
                    [placeholder]="'Stock Item#'"
                    [textField]="'number'"
                    [valueField]="'id'"
                    class="bordered"
                    required>
                    <ng-template kendoComboBoxItemTemplate let-dataItem>
                      <div class="transactions-receive-stock-dropdown-item">
                        <div class="truncate">{{ dataItem.number }}</div>
                        <div class="transactions-receive-stock-dropdown-item-description truncate">
                          {{ dataItem.itemType.name }}
                          @if (dataItem.description) {
                            <span>| {{ dataItem.description }}</span>
                          }
                        </div>
                      </div>
                    </ng-template>
                  </kendo-combobox>
                  <span class="asap-input-icon"
                    [class.disabled]="_form.get('accountfromid').value == null || _form.get('sitefromid').value == null || _form.get('accounttoid').value == null || _form.get('sitetoid').value == null"
                    (click)="_selectStocksHandler()">
                    <img class="addIcon"
                      [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                    </span>
                  </div>
                </div>
                <div class="Transfer-stock-right-checkbox">
                  <input type="checkbox" class="k-checkbox" kendoCheckBox />
                  <div class="Transfer-stock-right-checkbox-text">Quick Scan</div>
                </div>
              </div>
              <div class="col-12 display-flex margin-top-5">
                <div class="row flex-1">
                  <div class="col-4">
                    <label class="control-label">Transfer Quantity</label>
                  </div>
                  <div class="col-8 combobox_contaainer">
                    <kendo-numerictextbox #quantity_input
                      class="k-textbox writebox"
                      [min]="0"
                      [formControl]="_quantity"
                      (keyup.enter)="_quantitySubmited()"
                    (keydown.Tab)="_quantitySubmited()"></kendo-numerictextbox>
                  </div>
                </div>
                <div class="Transfer-stock-right-checkbox">
                  <input type="checkbox"
                    class="k-checkbox"
                    [formControl]="_defaultQuantity"
                    kendoCheckBox />
                    <div class="Transfer-stock-right-checkbox-text">
                      Set as Default
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="section-separator"></div>
                </div>
                <div class="col-12 display-flex">
                  <div class="row flex-1">
                    <div class="col-4">
                      <label class="control-label"> Attached Document </label>
                    </div>
                    <div class="col-8 combobox_contaainer" [class.disabled]="true">
                      <input type="text"
                        class="k-textbox writebox min-width-0"
                        placeholder="Upload file.." />
                        <a class="cursor-pointer" href="#">
                          <img class="searchIcon"
                            [src]="'/assets/menu/'+ _theme +'/search-icon.svg'" />
                          </a>
                          <a class="cursor-pointer" href="#">
                            <img class="searchIcon"
                              [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                            </a>
                          </div>
                        </div>
                        <div class="Transfer-stock-right-checkbox empty"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="TransferWidget with-grid">
                    <div class="Transfer-grid-header-wrapper">
                      <div class="row">
                        <div class="col-12">
                          <p class="titleStandardStyle">Pending Transaction</p>
                        </div>
                        <!-- <div class="col-6">
                        <ul class="buttonssectionList">
                          <li (click)="_selectStocksHandler()">
                            <span>
                              <img class="deleteicon"
                              [src]="'/assets/menu/'+ _theme +'/select-stock-icon.svg'" /></span>Select
                              Stock
                            </li>
                          </ul>
                        </div> -->
                      </div>
                    </div>
                    <kendo-grid [data]="_stockGridData"
                      [scrollable]="'none'"
                      class="TransferRequest-grid"
                      (remove)="_removeHandler($event)">
                      <kendo-grid-column field="stockNumber" title="Stock Item #">
                      </kendo-grid-column>
                      <kendo-grid-column field="description"
                        title="Stock Description"
                        [width]="250">
                      </kendo-grid-column>
                      <kendo-grid-column field="transferQuantity"
                        title="Transfer Quantity"
                        [width]="150">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <kendo-numerictextbox class="TransferRequest-grid-quantity"
                            [value]="dataItem.transferQuantity"
                            (valueChange)="_onTransferQuantityChange($event, dataItem)"
                            [min]="0">
                          </kendo-numerictextbox>
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="uom" title="UOM Code">
                      </kendo-grid-column>
                      <kendo-grid-column field="unitCost" title="Unit Cost" [width]="150">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <kendo-numerictextbox class="TransferRequest-grid-quantity"
                            [value]="dataItem.unitCost"
                            [min]="0"
                            [disabled]="true"
                            [format]="_costFormat">
                          </kendo-numerictextbox>
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="extendedCost"
                        title="Extended Cost"
                        [width]="150">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <kendo-numerictextbox class="TransferRequest-grid-quantity"
                            [value]="dataItem.extendedCost"
                            [min]="0"
                            [disabled]="true"
                            [format]="_costFormat">
                          </kendo-numerictextbox>
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-checkbox-column field="isTaxable" title="Taxable">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <input type="checkbox"
                            class="k-checkbox"
                            kendoCheckBox
                            [checked]="dataItem.isTaxable"
                            [disabled]="true" />
                          </ng-template>
                        </kendo-grid-checkbox-column>
                        <kendo-grid-command-column title="Action" [width]="250">
                          <ng-template kendoGridCellTemplate>
                            <div kendoGridRemoveCommand class="asap-grid-remove">
                              <div class="asap-grid-remove-icon">
                                <img src="/assets/menu/enterprise/remove-icon.svg" />
                              </div>
                              <div class="asap-grid-remove-text">Delete</div>
                            </div>
                          </ng-template>
                        </kendo-grid-command-column>
                      </kendo-grid>
                    </div>
                  </div>
                </div>
                @if (_showStocksGrid) {
                  <kendo-window
                    title="{{'Add Stock to Transfer Request'}}"
                    (close)="_closeStocksWindow()"
                    class="addFromLibrary">
                    <div class="greytabtop">
                      <button kendoButton
                        class="topRightButtonSelect"
                        (click)="_returnSelectedStocksHandler($event)">
                        Select & Return
                      </button>
                    </div>
                    @if (_stockItemsGridColumns) {
                      <asap-grid-layout
                        [page]="'stockItems'"
                        [entityName]="'stock'"
                        [sortingEnabled]="true"
                        [enableSiteSelection]="false"
                        [resolver]="_getStockItems"
                        [orderEnable]="true"
                        class="ListGrid"
                        [selectable]="true"
                        [pagingEnabled]="true"
                        [selectByField]="_selectedCallback"
                        [filteringEnable]="true"
                        [addNewFormEnabled]="false"
                        [deletedEnabled]="false"
                        [headerEnable]="true"
                        [groupingEnabled]="true"
                        [enableSiteSelection]="false"
                        (onRowSelectionChanges)="_onStockRowSelectionChanges($event)">
                        @for (column of _stockItemsGridColumns; track column) {
                          @if (column.selected) {
                            @if (column.isTemplate) {
                              <ng-template pageListColumn [field]="column.field"
                                [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title" [type]="column.type" let-item>
                                @if (column?.type == 'date') {
                                  {{ item[column.field] | dateFormat }}
                                }
                                <!-- <ng-container
                    *ngIf="(column?.type != 'date' || column.type==null )
                && column.formatType != quantityFormatType && column.formatType != costPriceFormatType ">&& column.field != 'quantityPerAccount'
                                {{item[column.field]}}
                                {{getFieldValue(item,column.field)}}
                                {{column.field | complexFieldValue: item}}
                              </ng-container> -->
                              @if (column.isCustomField == true) {
                                {{item[column.field]}}
                              }
                              @if (column.field == 'stockItemSites.account.name') {
                                {{getAccountNames(item.stockItemSites)}}
                              }
                              @if (column.formatType == costPriceFormatType) {
                                {{column.field | complexFieldValue: item | costFormat}}
                              }
                              @if (column.formatType == quantityFormatType ) {
                                {{column.field | complexFieldValue: item | quantityFormat}}
                              }
                              @if (column.field =='site.code' || column.field == 'site.name') {
                                {{item.site == null ? 'All Sites' : column.field | complexFieldValue: item}}
                              }
                            </ng-template>
                          }
                          @if (!column.isTemplate ) {
                            <!--&& _currentUser.isEnterprise == false  && column.field != 'quantityPerAccount' -->
                            <ng-template pageListColumn [field]="column.field"
                              [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title" [type]="column.type" let-item>
                              @if (column.field == 'markupType') {
                                {{ getMarkupType(item,column.field) }}
                              }
                              @if (column.type == 'date' && column.isCustomField == false) {
                                {{ item[column?.field] | dateFormat }}
                              }
                              @if (column.type != 'date' && column.type != 'image' && column.isCustomField == false
                                && column.formatType != quantityFormatType && column.formatType != costPriceFormatType) {
                                @if (column.field == 'notes') {
                                  <a style="cursor: pointer;" (click)="_showStockItemNotesWindow(item.id)">
                                    <img class="notesIcon" [src]="'/assets/menu/'+ _theme +'/note-icon.svg'" />
                                  </a>
                                }
                                @if (column.field != 'notes') {
                                  <label>
                                    {{column.field | complexFieldValue: item}}
                                  </label>
                                }
                              }
                              <!-- <ng-container
                              *ngIf="(column.type != 'date'  || column.type==null )&& column.field != 'category.categoryFiles.file.thumbnail'&&column.field != 'stockItemFiles.file.thumbnail'"><!-- && column.field != 'quantityPerAccount'
                              {{column.field | complexFieldValue: item}}
                            </ng-container> -->
                            @if (column.isCustomField == true) {
                              {{item[column.field]}}
                            }
                            @if (column.field == 'category.categoryFiles.file.thumbnail' && column.type == 'image') {
                              @if (item.category.categoryFiles != undefined) {
                                <div class="Category-icon">
                                  <img [src]="displayCatImage(column.field | complexFieldValue: item,item.category.categoryFiles)"
                                    appImagePopup width="100" />
                                  </div>
                                }
                              }
                              @if (column.field == 'stockItemFiles.file.thumbnail' && column.type == 'image') {
                                @if (item.stockItemFiles != undefined) {
                                  <div class="Category-icon">
                                    <img [src]="displayStockImage(column.field | complexFieldValue: item,item.stockItemFiles)"
                                      width="100" appImagePopup />
                                      <!-- (click)="openStockImagePopup(item.stockItemFiles)" -->
                                    </div>
                                  }
                                }
                              </ng-template>
                            }
                          }
                        }
                      </asap-grid-layout>
                    }
                  </kendo-window>
                }
                <div class="row">
                  <div class="col-12">
                    @if (_invalidForm) {
                      <asap-forms-validation-summary
                        [form]="_form"
                        [page]="'transferRequests'">
                      </asap-forms-validation-summary>
                    }
                  </div>
                </div>
              </form>
            </kendo-window>
          }
